import './front.scss';
import { StackedAssetsFront } from './StackedAssetsFront.js';

new StackedAssetsFront( document ).init();
